<template>

    <v-select :model="val" @input="val = $event">
        <option value="">{{ $t('labels.none') }}</option>
        <option v-for="l in locations" :key="l.id" :value="l.id">{{ l.title }}</option>
    </v-select>

</template>

<script>

export default {

    props: {
        model: {
            required: true,
        },
    },

    data() {
        return {
            val: this.model !== null && this.model !== undefined ? this.model : '',
        }
    },

    computed: {

        locations() {
            return this.project.locations;
        },

    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

}

</script>
